import { Injectable, inject } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { GenericAlertButton, GenericAlertData, GenericAlertDialog } from '../shared/dialogs';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DialogsService {
  readonly dialog = inject(MatDialog);

  confirmDeletion(type: string, ...names: string[]): MatDialogRef<any, boolean>;
  confirmDeletion(type: string, name: string): MatDialogRef<any, boolean>;
  confirmDeletion(type: string, names: string | string[]): MatDialogRef<any, boolean> {
    return <any>this.dialog.open(GenericAlertDialog, {
      width: '560px',
      data: <GenericAlertData>{
        title: 'Alert',
        content: `
          <p>Are you sure you want to delete the following <strong>${type}</strong>?</p>
          <p><strong>${Array.isArray(names) ? names.join(', ') : names}</strong></p>
          `,
        buttons: [GenericAlertButton.cancel, GenericAlertButton.delete]
      },
    });
  }

  openAlert(data: GenericAlertData, options?: MatDialogConfig<GenericAlertDialog>): MatDialogRef<any, boolean> {
    return <any>this.dialog.open(GenericAlertDialog, {
      width: '560px',
      ...options,
      data: <GenericAlertData>{
        ...data
      }
    });
  }
}
